import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { ContextDocument } from '../../../types/ai.types'

export const AiDocumentsActions = createActionGroup({
  source: 'AiDocuments',
  events: {
    loadDocuments: emptyProps(),
    loadDocumentsSuccess: props<{ documents: ContextDocument[] }>(),
  },
})
